import {
  GET_CUSTOMERS_REQUEST,
  GET_CUSTOMERS_SUCCESS,
  GET_CUSTOMERS_FAILURE,
  CREATE_CUSTOMER_REQUEST,
  CREATE_CUSTOMER_SUCCESS,
  CREATE_CUSTOMER_FAILURE,
  UPDATE_CUSTOMER_REQUEST,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_FAILURE,
  DELETE_CUSTOMER_REQUEST,
  DELETE_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_FAILURE,
} from '../types';
import api from '../../services/api';

// Get all customers
export const getCustomers = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_CUSTOMERS_REQUEST });

    const response = await api.get('/master/customers', { params });
    const data = response.data.data;

    dispatch({
      type: GET_CUSTOMERS_SUCCESS,
      payload: data,
    });

    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to get customers';
    dispatch({
      type: GET_CUSTOMERS_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Create customer
export const createCustomer = (customerData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_CUSTOMER_REQUEST });

    const response = await api.post('/master/customers', customerData);
    const customer = response.data.data;

    dispatch({
      type: CREATE_CUSTOMER_SUCCESS,
      payload: customer,
    });

    return { success: true, data: customer };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to create customer';
    dispatch({
      type: CREATE_CUSTOMER_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Update customer
export const updateCustomer = (id, customerData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_CUSTOMER_REQUEST });

    const response = await api.put(`/master/customers/${id}`, customerData);
    const customer = response.data.data;

    dispatch({
      type: UPDATE_CUSTOMER_SUCCESS,
      payload: customer,
    });

    return { success: true, data: customer };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update customer';
    dispatch({
      type: UPDATE_CUSTOMER_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Delete customer
export const deleteCustomer = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_CUSTOMER_REQUEST });

    await api.delete(`/master/customers/${id}`);

    dispatch({
      type: DELETE_CUSTOMER_SUCCESS,
      payload: id,
    });

    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to delete customer';
    dispatch({
      type: DELETE_CUSTOMER_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};
